import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";
import AddEmployeeSkill from "./AddEmployeeSkill";
import GetAllEmployeeSkills from "./GetAllEmployeeSkills";
import { Col, Row, Form } from "antd";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";

const EmployeeSkills = () => {
	const [form] = Form.useForm();
	const dispatch = useDispatch();
	const isLogged = Boolean(localStorage.getItem("isLogged"));
	const staffList = useSelector((state) => state.users?.list || []);

	const [skillsList, setSkillsList] = useState(() => {
		// Try to load from localStorage first
		const storedSkills = localStorage.getItem("employeeSkills");
		if (storedSkills) {
			try {
				return JSON.parse(storedSkills);
			} catch (error) {
				console.error("Error parsing skills from localStorage:", error);
			}
		}
		// Default dummy data
		const now = dayjs();
		return [
			{
				id: 1,
				employeeId: 1,
				employeeName: "Pradeep Kumar",
				skillCategory: "Programming",
				skillName: "React.js",
				proficiencyLevel: "Advanced",
				currentRating: 4.5,
				targetRating: 5.0,
				assessmentDate: now.subtract(30, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(365, "day").format("YYYY-MM-DD"),
				certificationName: "React Developer Certification",
				certificationDate: now.subtract(180, "day").format("YYYY-MM-DD"),
				certificationProvider: "Meta",
				trainingCompleted: "React Advanced Patterns, React Hooks Mastery, State Management",
				experienceYears: 2.5,
				workExamples: "Built 3 major React applications, implemented complex state management, optimized performance",
				notes: "Strong in React ecosystem, working on becoming expert level",
				status: "Active",
			},
			{
				id: 2,
				employeeId: 1,
				employeeName: "Pradeep Kumar",
				skillCategory: "Programming",
				skillName: "Node.js",
				proficiencyLevel: "Intermediate",
				currentRating: 3.5,
				targetRating: 4.5,
				assessmentDate: now.subtract(15, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(180, "day").format("YYYY-MM-DD"),
				certificationName: null,
				certificationDate: null,
				certificationProvider: null,
				trainingCompleted: "Node.js Fundamentals, Express.js Basics",
				experienceYears: 1.5,
				workExamples: "Developed REST APIs, worked on backend services",
				notes: "Improving backend development skills",
				status: "In Progress",
			},
			{
				id: 3,
				employeeId: 2,
				employeeName: "Anshuman Singh",
				skillCategory: "Soft Skills",
				skillName: "Public Speaking",
				proficiencyLevel: "Advanced",
				currentRating: 4.0,
				targetRating: 4.5,
				assessmentDate: now.subtract(20, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(730, "day").format("YYYY-MM-DD"),
				certificationName: "Public Speaking Mastery",
				certificationDate: now.subtract(365, "day").format("YYYY-MM-DD"),
				certificationProvider: "Toastmasters",
				trainingCompleted: "Toastmasters International Program, Presentation Skills Workshop",
				experienceYears: 2.0,
				workExamples: "Presented at 5 company events, led client presentations, conducted training sessions",
				notes: "Excellent communication skills, regularly presents to stakeholders",
				status: "Active",
			},
			{
				id: 4,
				employeeId: 2,
				employeeName: "Anshuman Singh",
				skillCategory: "Technical",
				skillName: "JavaScript",
				proficiencyLevel: "Intermediate",
				currentRating: 3.0,
				targetRating: 4.0,
				assessmentDate: now.subtract(10, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(180, "day").format("YYYY-MM-DD"),
				certificationName: null,
				certificationDate: null,
				certificationProvider: null,
				trainingCompleted: "JavaScript Fundamentals, ES6+ Features",
				experienceYears: 1.0,
				workExamples: "Working on JavaScript projects, learning advanced concepts",
				notes: "Focusing on improving JavaScript skills",
				status: "In Progress",
			},
			{
				id: 5,
				employeeId: 3,
				employeeName: "Priya Verma",
				skillCategory: "Tools & Technologies",
				skillName: "Git & Version Control",
				proficiencyLevel: "Intermediate",
				currentRating: 3.5,
				targetRating: 4.0,
				assessmentDate: now.subtract(25, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(120, "day").format("YYYY-MM-DD"),
				certificationName: null,
				certificationDate: null,
				certificationProvider: null,
				trainingCompleted: "Git Basics, GitHub Workflow",
				experienceYears: 0.5,
				workExamples: "Using Git for version control in projects",
				notes: "Learning advanced Git workflows",
				status: "In Progress",
			},
			{
				id: 6,
				employeeId: 4,
				employeeName: "Rahul Das",
				skillCategory: "Technical",
				skillName: "Python",
				proficiencyLevel: "Expert",
				currentRating: 5.0,
				targetRating: 5.0,
				assessmentDate: now.subtract(5, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(1825, "day").format("YYYY-MM-DD"),
				certificationName: "Python Professional Certification",
				certificationDate: now.subtract(730, "day").format("YYYY-MM-DD"),
				certificationProvider: "Python Institute",
				trainingCompleted: "Advanced Python Programming, Data Structures & Algorithms, Machine Learning with Python",
				experienceYears: 5.0,
				workExamples: "Built multiple enterprise applications, contributed to open source, mentored junior developers",
				notes: "Expert level Python developer, regularly contributes to technical discussions",
				status: "Active",
			},
			{
				id: 7,
				employeeId: 4,
				employeeName: "Rahul Das",
				skillCategory: "Leadership",
				skillName: "Team Leadership",
				proficiencyLevel: "Advanced",
				currentRating: 4.5,
				targetRating: 5.0,
				assessmentDate: now.subtract(15, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(365, "day").format("YYYY-MM-DD"),
				certificationName: "Leadership Development Program",
				certificationDate: now.subtract(180, "day").format("YYYY-MM-DD"),
				certificationProvider: "Corporate Training",
				trainingCompleted: "Leadership Essentials, Team Management, Conflict Resolution",
				experienceYears: 1.0,
				workExamples: "Led 2 project teams, mentored 5 junior developers, conducted team building activities",
				notes: "Strong leadership skills, ready for senior role",
				status: "Active",
			},
			{
				id: 8,
				employeeId: 5,
				employeeName: "Sara Smith",
				skillCategory: "Technical",
				skillName: "HTML/CSS",
				proficiencyLevel: "Beginner",
				currentRating: 2.0,
				targetRating: 3.5,
				assessmentDate: now.subtract(7, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(60, "day").format("YYYY-MM-DD"),
				certificationName: null,
				certificationDate: null,
				certificationProvider: null,
				trainingCompleted: "HTML/CSS Basics Course",
				experienceYears: 0.2,
				workExamples: "Working on basic HTML/CSS projects",
				notes: "New to web development, learning fundamentals",
				status: "In Progress",
			},
			{
				id: 9,
				employeeId: 1,
				employeeName: "Pradeep Kumar",
				skillCategory: "Project Management",
				skillName: "Agile Methodology",
				proficiencyLevel: "Intermediate",
				currentRating: 3.5,
				targetRating: 4.5,
				assessmentDate: now.subtract(40, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(180, "day").format("YYYY-MM-DD"),
				certificationName: "Certified Scrum Master",
				certificationDate: now.subtract(90, "day").format("YYYY-MM-DD"),
				certificationProvider: "Scrum Alliance",
				trainingCompleted: "Scrum Master Training, Agile Fundamentals",
				experienceYears: 1.5,
				workExamples: "Led 2 sprint cycles, facilitated daily standups, managed backlog",
				notes: "Working towards Advanced Scrum Master certification",
				status: "Active",
			},
			{
				id: 10,
				employeeId: 3,
				employeeName: "Priya Verma",
				skillCategory: "Communication",
				skillName: "Technical Writing",
				proficiencyLevel: "Beginner",
				currentRating: 2.5,
				targetRating: 4.0,
				assessmentDate: now.subtract(12, "day").format("YYYY-MM-DD"),
				acquiredDate: now.subtract(90, "day").format("YYYY-MM-DD"),
				certificationName: null,
				certificationDate: null,
				certificationProvider: null,
				trainingCompleted: "Technical Writing Basics",
				experienceYears: 0.3,
				workExamples: "Writing project documentation",
				notes: "Improving documentation skills",
				status: "In Progress",
			},
		];
	});

	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	const mapEmployeeName = (employeeId) => {
		const employee = staffList.find((e) => e.id === employeeId);
		if (employee) {
			return (
				employee.EmployeeName ||
				`${employee.firstName || ""} ${employee.lastName || ""}`.trim() ||
				employee.UserName
			);
		}
		return "Unknown";
	};

	const handleSubmit = (values) => {
		const newId = skillsList.length ? Math.max(...skillsList.map((s) => s.id || 0)) + 1 : 1;
		const payload = {
			id: newId,
			employeeId: values.employeeId,
			employeeName: mapEmployeeName(values.employeeId),
			skillCategory: values.skillCategory,
			skillName: values.skillName,
			proficiencyLevel: values.proficiencyLevel || "Beginner",
			currentRating: values.currentRating || 0,
			targetRating: values.targetRating || 0,
			assessmentDate: values.assessmentDate ? dayjs(values.assessmentDate).format("YYYY-MM-DD") : null,
			acquiredDate: values.acquiredDate ? dayjs(values.acquiredDate).format("YYYY-MM-DD") : null,
			certificationName: values.certificationName || "",
			certificationDate: values.certificationDate ? dayjs(values.certificationDate).format("YYYY-MM-DD") : null,
			certificationProvider: values.certificationProvider || "",
			trainingCompleted: values.trainingCompleted || "",
			experienceYears: values.experienceYears || 0,
			workExamples: values.workExamples || "",
			notes: values.notes || "",
			status: values.status || "Active",
		};
		setSkillsList((prev) => [...prev, payload]);
		form.resetFields();
	};

	const handleEdit = (record) => {
		form.setFieldsValue({
			employeeId: record.employeeId,
			skillCategory: record.skillCategory,
			skillName: record.skillName,
			proficiencyLevel: record.proficiencyLevel,
			currentRating: record.currentRating,
			targetRating: record.targetRating,
			assessmentDate: record.assessmentDate ? dayjs(record.assessmentDate) : null,
			acquiredDate: record.acquiredDate ? dayjs(record.acquiredDate) : null,
			certificationName: record.certificationName,
			certificationDate: record.certificationDate ? dayjs(record.certificationDate) : null,
			certificationProvider: record.certificationProvider,
			trainingCompleted: record.trainingCompleted,
			experienceYears: record.experienceYears,
			workExamples: record.workExamples,
			notes: record.notes,
			status: record.status,
		});
	};

	const refresh = () => {
		setSkillsList((prev) => [...prev]);
	};

	// Sync skills to localStorage whenever it changes
	useEffect(() => {
		localStorage.setItem("employeeSkills", JSON.stringify(skillsList));
	}, [skillsList]);

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}

	return (
		<div className="add-employee-skills-page-wrapper">
			<PageTitle title="Back" />
			<Row gutter={16} className="add-employee-skills-row">
				<Col xs={24} sm={24} md={10} lg={8} className="add-employee-skills-form-col">
					<AddEmployeeSkill form={form} onSubmit={handleSubmit} />
				</Col>
				<Col xs={24} sm={24} md={14} lg={16} className="add-employee-skills-table-col">
					<GetAllEmployeeSkills data={skillsList} onEdit={handleEdit} onRefresh={refresh} />
				</Col>
			</Row>
		</div>
	);
};

export default EmployeeSkills;

